export default "__VITE_ASSET__CywPPUhO__"